module.exports = __webpack_public_path__ + "img/bottom_icon10.2691fa36_2691fa366d762f442ddd3ff5c584a1d2.2691fa36.png";